import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const timelines = {}

export function registerTimeline(name, fn) {
  timelines[name] = fn
}

export function initScrollAnimations() {
  const root = document.querySelector('[data-scroll-timeline]')
  if (!root) return

  const name = root.dataset.scrollTimeline
  const build = timelines[name]
  if (!build) return

  const container = document.getElementById('scroll-container')
  if (container) {
    ScrollTrigger.defaults({ scroller: container })

    // Forward wheel events on desktop: body has overflow:hidden so native
    // scroll bubbling stops there. We manually proxy wheel → container.scrollBy.
    document.addEventListener('wheel', (e) => {
      container.scrollBy({ top: e.deltaY, left: e.deltaX })
      e.preventDefault()
    }, { passive: false })
  }

  build(root, container)
}

export { gsap, ScrollTrigger }
